import script from "./LeftMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./LeftMenu.vue?vue&type=script&lang=ts&setup=true"

import "./LeftMenu.vue?vue&type=style&index=0&id=c97a1d12&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c97a1d12"]])

export default __exports__